(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2667],{

/***/ 4055:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/[...category]",
      function () {
        return __webpack_require__(49488);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CATEGORY_FRAGMENT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70463);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment category on Category {\n    id\n    name\n    title\n    url\n    visible\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CATEGORY_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 9726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useAnalyticsEventAfterPageviewEventHasFired; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _usePageEventsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43308);


var useAnalyticsEventAfterPageviewEventHasFired = function(event, deps) {
    var pageviewEventHasFired = (0,_usePageEventsContext__WEBPACK_IMPORTED_MODULE_1__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (pageviewEventHasFired) event();
    }, [
        pageviewEventHasFired,
        event,
        deps
    ]);
};


/***/ }),

/***/ 49488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _category_; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useGroqQuery.ts
var useGroqQuery = __webpack_require__(95967);
// EXTERNAL MODULE: ./ui/components/NoSearchResults.tsx + 2 modules
var NoSearchResults = __webpack_require__(20769);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./ui/components/Page.tsx + 1 modules
var Page = __webpack_require__(87150);
// EXTERNAL MODULE: ./ui/components/PageHead.tsx
var PageHead = __webpack_require__(9294);
// EXTERNAL MODULE: ./ui/components/SanityContentSlot.tsx + 53 modules
var SanityContentSlot = __webpack_require__(2232);
// EXTERNAL MODULE: ./groq/pages/MarketingPage.ts
var MarketingPage = __webpack_require__(89759);
// EXTERNAL MODULE: ./utils/getUrlByCategory.ts
var getUrlByCategory = __webpack_require__(21867);
;// CONCATENATED MODULE: ./ui/pages/MarketingPage.tsx











var MarketingPage_MarketingPage = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var category = router.query.category;
    var url = (0,getUrlByCategory/* getUrlByCategory */.M)(category);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "MarketingPage",
        query: MarketingPage/* MarketingPageQuery */.F,
        variables: {
            url: url
        }
    }), 1), marketingPage = ref1[0];
    var categoryContent = (ref = marketingPage.data) === null || ref === void 0 ? void 0 : ref.content;
    var seo = categoryContent === null || categoryContent === void 0 ? void 0 : categoryContent.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* PageHead */.y, {
                noIndex: seo === null || seo === void 0 ? void 0 : seo.noIndex,
                title: (seo === null || seo === void 0 ? void 0 : seo.pageTitle) && (seo === null || seo === void 0 ? void 0 : seo.pageTitle.length) > 0 ? seo === null || seo === void 0 ? void 0 : seo.pageTitle : seo === null || seo === void 0 ? void 0 : seo.pageTitles,
                description: (seo === null || seo === void 0 ? void 0 : seo.pageDescription) && (seo === null || seo === void 0 ? void 0 : seo.pageDescription.length) > 0 ? seo === null || seo === void 0 ? void 0 : seo.pageDescription : seo === null || seo === void 0 ? void 0 : seo.pageDescriptions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* Page */.T, {
                pageViewPageType: "mlp",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, marketingPage), {
                    fetching: marketingPage.fetching || marketingPage.stale
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                    items: categoryContent === null || categoryContent === void 0 ? void 0 : categoryContent.content,
                    slotId: "slots",
                    documentId: categoryContent === null || categoryContent === void 0 ? void 0 : categoryContent._id,
                    fullscreen: true,
                    headersContent: categoryContent === null || categoryContent === void 0 ? void 0 : categoryContent.headersContent
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/components/Hreflangs.tsx + 1 modules
var Hreflangs = __webpack_require__(5773);
// EXTERNAL MODULE: ./utils/hardcodedHreflangs.ts
var hardcodedHreflangs = __webpack_require__(71021);
// EXTERNAL MODULE: ./groq/pages/CategoryPage.ts
var CategoryPage = __webpack_require__(37333);
;// CONCATENATED MODULE: ./ui/pages/CategoryPage.tsx













var CategoryPage_CategoryPage = function() {
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var category = router.query.category;
    var url = (0,getUrlByCategory/* getUrlByCategory */.M)(category);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "CategoryPage",
        query: CategoryPage/* CategoryPageQuery */.U,
        variables: {
            url: url
        }
    }), 1), categoryPage = ref4[0];
    var categoryGeneralId = (ref = categoryPage.data) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.id;
    var categoryContent = (ref2 = categoryPage.data) === null || ref2 === void 0 ? void 0 : ref2.content;
    var seo = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, categoryContent === null || categoryContent === void 0 ? void 0 : categoryContent.seo), {
        noIndex: categoryContent === null || categoryContent === void 0 ? void 0 : (ref3 = categoryContent.categoryPageSEO) === null || ref3 === void 0 ? void 0 : ref3.noIndex
    });
    var title = categoryContent === null || categoryContent === void 0 ? void 0 : categoryContent.title;
    var ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* PageHead */.y, {
                title: seo === null || seo === void 0 ? void 0 : seo.pageTitle,
                description: (ref5 = seo === null || seo === void 0 ? void 0 : seo.pageDescription) !== null && ref5 !== void 0 ? ref5 : "",
                noIndex: seo === null || seo === void 0 ? void 0 : seo.noIndex,
                openGraphDescription: (ref6 = seo === null || seo === void 0 ? void 0 : seo.openGraphDescription) !== null && ref6 !== void 0 ? ref6 : "",
                openGraphImageUrl: (ref7 = seo === null || seo === void 0 ? void 0 : seo.openGraphImageUrl) !== null && ref7 !== void 0 ? ref7 : "",
                openGraphTitle: (ref8 = seo === null || seo === void 0 ? void 0 : seo.openGraphTitle) !== null && ref8 !== void 0 ? ref8 : "",
                openGraphType: (ref9 = seo === null || seo === void 0 ? void 0 : seo.openGraphType) !== null && ref9 !== void 0 ? ref9 : "",
                openGraphVideoUrl: (ref10 = seo === null || seo === void 0 ? void 0 : seo.openGraphVideoUrl) !== null && ref10 !== void 0 ? ref10 : "",
                twitterDescription: (ref11 = seo === null || seo === void 0 ? void 0 : seo.twitterDescription) !== null && ref11 !== void 0 ? ref11 : "",
                twitterImageUrl: (ref12 = seo === null || seo === void 0 ? void 0 : seo.twitterImageUrl) !== null && ref12 !== void 0 ? ref12 : "",
                twitterTitle: (ref13 = seo === null || seo === void 0 ? void 0 : seo.twitterTitle) !== null && ref13 !== void 0 ? ref13 : "",
                noHreflangs: hardcodedHreflangs/* availablePages.includes */.y.includes(categoryGeneralId || "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hreflangs/* Hreflangs */.k, {
                id: categoryGeneralId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* Page */.T, {
                pageViewPageType: "clp",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, categoryPage), {
                    fetching: categoryPage.fetching || categoryPage.stale
                }),
                bloomreachData: {
                    cat: title,
                    cat_id: categoryContent === null || categoryContent === void 0 ? void 0 : categoryContent._id
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                    items: categoryContent === null || categoryContent === void 0 ? void 0 : categoryContent.content,
                    slotId: "slots",
                    documentId: categoryContent === null || categoryContent === void 0 ? void 0 : categoryContent._id,
                    fullscreen: true,
                    headersContent: categoryContent === null || categoryContent === void 0 ? void 0 : categoryContent.headersContent
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
// EXTERNAL MODULE: ./ui/elements/SafeHtml.tsx
var SafeHtml = __webpack_require__(99671);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
;// CONCATENATED MODULE: ./ui/components/InlineReadMore.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & a {\n    @apply underline font-bold;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & p {\n    @apply inline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var linkStyles = (0,css/* css */.iv)(_templateObject());
var paragraphStyles = (0,css/* css */.iv)(_templateObject1());
var InlineReadMore = function(param) {
    var className = param.className, innerHtmlString = param.innerHtmlString;
    var isDividerEnabled = (0,useFeature/* useFeature */.S)("USE_SFCC_DIVIDER_FOR_SEO_DESCRIPTION");
    var containerClassName = (0,css.tw)(className, paragraphStyles, isDividerEnabled && linkStyles);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: containerClassName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtml/* SafeHtml */.T, {
            className: "inline",
            html: innerHtmlString
        })
    });
};

// EXTERNAL MODULE: ./hooks/useHeading.tsx
var useHeading = __webpack_require__(99592);
// EXTERNAL MODULE: ./ui/components/ManagedHeading.tsx
var ManagedHeading = __webpack_require__(93512);
// EXTERNAL MODULE: ./ui/components/ProductList.tsx + 2 modules
var ProductList = __webpack_require__(79072);
// EXTERNAL MODULE: ./ui/components/Breadcrumb.tsx + 1 modules
var Breadcrumb = __webpack_require__(37404);
// EXTERNAL MODULE: ./utils/constructCategoryPath.ts
var constructCategoryPath = __webpack_require__(97729);
// EXTERNAL MODULE: ./utils/breadcrumbRedirects.ts + 1 modules
var breadcrumbRedirects = __webpack_require__(5567);
// EXTERNAL MODULE: ./utils/serializeBlockContent.tsx
var serializeBlockContent = __webpack_require__(88313);
// EXTERNAL MODULE: ./ui/components/ProductListItem.tsx + 6 modules
var ProductListItem = __webpack_require__(4291);
// EXTERNAL MODULE: ./ui/elements/ScrollToTopButton.tsx
var ScrollToTopButton = __webpack_require__(39454);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ./gql/fragments/category.ts
var category = __webpack_require__(83677);
// EXTERNAL MODULE: ./gql/fragments/products.ts
var products = __webpack_require__(46709);
// EXTERNAL MODULE: ./gql/fragments/product.ts
var product = __webpack_require__(19404);
// EXTERNAL MODULE: ./gql/queries/products.ts
var queries_products = __webpack_require__(78217);
;// CONCATENATED MODULE: ./gql/queries/plp.ts



function plp_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CategoryPLP(\n    $url: String!\n    $isDraft: String\n    $sort: String\n    $filters: [FilterInputOption!]!\n    $expansions: [ProductSearchExpansion!]\n    $includeCategoryMetadata: Boolean = true\n    $offset: Int!\n    $limit: Int!\n    $preview: PreviewInput\n  ) {\n    categoryByUrl(url: $url, preview: $preview) {\n      id\n      name\n      url\n      disableRatings\n      ...category @include(if: $includeCategoryMetadata)\n      description @include(if: $includeCategoryMetadata)\n      products(\n        input: {\n          sort: $sort\n          filters: $filters\n          limit: $limit\n          offset: $offset\n          expansions: $expansions\n          includeCategoryMetadata: $includeCategoryMetadata\n          isDraft: $isDraft\n        }\n      ) {\n        ...PaginatedOutputNodesFragment\n        ...PaginatedOutputMetadataFragment\n          @include(if: $includeCategoryMetadata)\n      }\n      seo @include(if: $includeCategoryMetadata) {\n        pageTitle\n        pageDescription\n      }\n      parentCategory {\n        ...category\n        parentCategory {\n          ...category\n          parentCategory {\n            ...category\n            parentCategory {\n              ...category\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    plp_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CATEGORY_PLP_QUERY = (0,urql_core/* gql */.Ps)(plp_templateObject(), category/* CATEGORY_FRAGMENT */.A, products/* PAGINATED_OUTPUT_NODES_FRAGMENT */.L, products/* PAGINATED_OUTPUT_METADATA_FRAGMENT */.q, product/* MANDATORY_MASTER_FIELDS */.YP, product/* MANDATORY_VARIANT_FIELDS */.EN);
var useCategoryPLPQuery = function(options) {
    var query = (0,urql_es/* useQuery */.aM)({
        query: CATEGORY_PLP_QUERY,
        pause: options.pause,
        variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,queries_products/* commonQueryVariables */.J)(options)), {
            url: options.url,
            src: options.src,
            preview: options.preview,
            includeCategoryMetadata: options.includeMetadata
        })
    });
    return query;
};

// EXTERNAL MODULE: ./utils/products.ts
var utils_products = __webpack_require__(1032);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./ui/components/ProductListFilterProvider.tsx
var ProductListFilterProvider = __webpack_require__(64648);
// EXTERNAL MODULE: ./utils/isInitialClientRender.ts
var isInitialClientRender = __webpack_require__(64191);
;// CONCATENATED MODULE: ./utils/filterActivated.ts
var filterActivated = function(queryParams) {
    return [
        "pref_color",
        "pref_fit",
        "pref_maxPrice",
        "pref_minPrice",
        "pref_size",
        "pref_style",
        "sort", 
    ].some(function(filter) {
        return Object.keys(queryParams).includes(filter);
    });
};

// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./utils/getPreviewInput.ts
var getPreviewInput = __webpack_require__(14106);
;// CONCATENATED MODULE: ./ui/components/RelatedLinks.tsx


var checkTitles = function(childCategories, siblingCategories, customLinks) {
    var ref, ref1, ref2, ref3;
    var childCategoriesTitle = (childCategories === null || childCategories === void 0 ? void 0 : (ref = childCategories.categories) === null || ref === void 0 ? void 0 : ref.length) === 0 || (childCategories === null || childCategories === void 0 ? void 0 : (ref1 = childCategories.title) === null || ref1 === void 0 ? void 0 : ref1.length) > 0;
    var siblingCategoriesTitle = (siblingCategories === null || siblingCategories === void 0 ? void 0 : (ref2 = siblingCategories.categories) === null || ref2 === void 0 ? void 0 : ref2.length) === 0 || (siblingCategories === null || siblingCategories === void 0 ? void 0 : (ref3 = siblingCategories.title) === null || ref3 === void 0 ? void 0 : ref3.length) > 0;
    var customLinksTitle = !customLinks || (customLinks === null || customLinks === void 0 ? void 0 : customLinks.every(function(link) {
        var ref, ref1;
        return (link === null || link === void 0 ? void 0 : (ref = link.title) === null || ref === void 0 ? void 0 : ref.length) > 0 || (link === null || link === void 0 ? void 0 : (ref1 = link.links) === null || ref1 === void 0 ? void 0 : ref1.length) === 0;
    }));
    return childCategoriesTitle && siblingCategoriesTitle && customLinksTitle;
};
var renderCategoriesColumn = function(categories, title, showTitles, activeRelatedLinks) {
    if (typeof activeRelatedLinks === "object" && !categories.some(function(category) {
        return activeRelatedLinks === null || activeRelatedLinks === void 0 ? void 0 : activeRelatedLinks.some(function(link) {
            return link._key === category._id;
        });
    })) {
        return null;
    }
    if (!categories || categories.length === 0 || !categories.some(function(category) {
        var ref, ref1;
        return ((category === null || category === void 0 ? void 0 : category.url) || (category === null || category === void 0 ? void 0 : (ref = category.category) === null || ref === void 0 ? void 0 : ref.url)) && ((category === null || category === void 0 ? void 0 : category.name) || (category === null || category === void 0 ? void 0 : (ref1 = category.category) === null || ref1 === void 0 ? void 0 : ref1.name) || (category === null || category === void 0 ? void 0 : category.title));
    })) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pr-2 w-full max-w-[268px]",
        children: [
            showTitles && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "font-bold mb-4 uppercase",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "gap-3 grid",
                children: categories.map(function(category, index) {
                    var ref, ref1, ref2, ref3;
                    return ((category === null || category === void 0 ? void 0 : category.url) || (category === null || category === void 0 ? void 0 : (ref = category.category) === null || ref === void 0 ? void 0 : ref.url)) && (!activeRelatedLinks || (activeRelatedLinks === null || activeRelatedLinks === void 0 ? void 0 : activeRelatedLinks.some(function(link) {
                        return link._key === category._id;
                    }))) && ((category === null || category === void 0 ? void 0 : category.name) || (category === null || category === void 0 ? void 0 : (ref1 = category.category) === null || ref1 === void 0 ? void 0 : ref1.name) || (category === null || category === void 0 ? void 0 : category.title)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (category === null || category === void 0 ? void 0 : category.url) || (category === null || category === void 0 ? void 0 : (ref2 = category.category) === null || ref2 === void 0 ? void 0 : ref2.url),
                            className: "underline uppercase",
                            children: (category === null || category === void 0 ? void 0 : category.name) || (category === null || category === void 0 ? void 0 : (ref3 = category.category) === null || ref3 === void 0 ? void 0 : ref3.name) || (category === null || category === void 0 ? void 0 : category.title)
                        })
                    }, index);
                })
            })
        ]
    });
};
var RelatedLinks = function(props) {
    var _relatedLinks = props.relatedLinks, childCategories = _relatedLinks.childCategories, siblingCategories = _relatedLinks.siblingCategories, customLinks = _relatedLinks.customLinks, activeRelatedLinks = _relatedLinks.activeRelatedLinks;
    if (!childCategories && !siblingCategories && !customLinks) {
        return null;
    }
    var showTitles = checkTitles(childCategories, siblingCategories, customLinks);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "related-links grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 mt-8 text-sm gap-x-4 gap-y-8",
        children: [
            renderCategoriesColumn(childCategories === null || childCategories === void 0 ? void 0 : childCategories.categories, childCategories === null || childCategories === void 0 ? void 0 : childCategories.title, showTitles, activeRelatedLinks),
            renderCategoriesColumn(siblingCategories === null || siblingCategories === void 0 ? void 0 : siblingCategories.categories, siblingCategories === null || siblingCategories === void 0 ? void 0 : siblingCategories.title, showTitles, activeRelatedLinks),
            customLinks === null || customLinks === void 0 ? void 0 : customLinks.map(function(customCategories) {
                return renderCategoriesColumn(customCategories === null || customCategories === void 0 ? void 0 : customCategories.links, customCategories === null || customCategories === void 0 ? void 0 : customCategories.title, showTitles, false);
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useIsCrawler.tsx
var useIsCrawler = __webpack_require__(32239);
// EXTERNAL MODULE: ./groq/ContentSlots.ts
var ContentSlots = __webpack_require__(18273);
// EXTERNAL MODULE: ./groq/objects/TileWithPosition.ts
var TileWithPosition = __webpack_require__(4287);
// EXTERNAL MODULE: ./groq/shared/LocaleSeo.ts + 1 modules
var LocaleSeo = __webpack_require__(16138);
// EXTERNAL MODULE: ./groq/shared/LocaleUrl.ts
var LocaleUrl = __webpack_require__(63950);
// EXTERNAL MODULE: ./groq/shared/LocaleString.ts
var LocaleString = __webpack_require__(1809);
// EXTERNAL MODULE: ./groq/shared/LocalePortableText.ts
var LocalePortableText = __webpack_require__(57831);
;// CONCATENATED MODULE: ./groq/pages/ProductListingPage.ts






var categoryData = "\n  _type,\n  ".concat((0,LocaleString/* LocaleString */.E)("name"), ",\n  ").concat(LocaleUrl/* LocaleUrl */.wS, ",\n  id,\n  _id\n");
var childCategories = "\n  childCategories {\n    _type,\n    categories[]->{\n      _type,\n      ".concat(categoryData, "\n    },\n    ").concat((0,LocaleString/* LocaleString */.E)("title"), "\n  }\n");
var siblingCategories = "\n  siblingCategories {\n    _type,\n    categories[]->{\n      _type,\n      ".concat(categoryData, "\n    },\n    ").concat((0,LocaleString/* LocaleString */.E)("title"), "\n  }\n");
var customLinks = "\n  customLinks[] {\n    links[] {\n      _type,\n      category->{\n        ".concat(categoryData, "\n      },\n      ").concat((0,LocaleString/* LocaleString */.E)("title"), "\n    },\n    ").concat((0,LocaleString/* LocaleString */.E)("title"), "\n  }\n");
var DefaultProductListingPageQuery = '\n  *[country == $country]\n   [_type == "ProductListingPage"]\n   ['.concat((0,LocaleUrl/* QueryByLocaleUrl */.KM)("category->"), "]\n   [0] {\n    _id,\n    _type,\n    relatedLinks {\n      _type,\n      ").concat(childCategories, ",\n      ").concat(siblingCategories, ",\n      ").concat(customLinks, ",\n      activeRelatedLinks[] {\n        ...\n      },\n      ").concat((0,LocaleString/* LocaleString */.E)("title"), '\n    },\n    recommenderEnabled,\n    recommenderId,\n    "seo": category->').concat((0,LocaleSeo/* LocaleSeo */.U)("seo"), ",\n    ").concat((0,TileWithPosition/* TileWithPositionObject */.k)("tiles[]"), ',\n    bottomSeoContent[] {\n      ...,\n      markDefs[]{\n        ...,\n        "link": @ -> url\n      }\n    }, \n    ').concat((0,LocalePortableText/* LocalePortableText */.O)("localeBottomSeoContent"), ",\n  }\n");
var TopContentSlotPLPQuery = '\n  *[country == $country]\n   [_type == "ProductListingPage"]\n   ['.concat((0,LocaleUrl/* QueryByLocaleUrl */.KM)("category->"), "]\n   [0] {\n    _id,\n    _type,\n    topContent[] ").concat((0,ContentSlots/* SlotsGroqQuery */.e6)(), ",\n  }\n");
var BottomContentSlotPLPQuery = '\n  *[country == $country]\n   [_type == "ProductListingPage"]\n   ['.concat((0,LocaleUrl/* QueryByLocaleUrl */.KM)("category->"), "]\n   [0] {\n    _id,\n    _type,\n    bottomContent[] ").concat((0,ContentSlots/* SlotsGroqQuery */.e6)(), ",\n  }\n");

// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
;// CONCATENATED MODULE: ./ui/pages/ProductListingPage/hooks/usePLPContent.tsx






var usePLPContent = function(categoryUrl, currentCategory, hasActiveFilter, hasExplicitSort) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "DefaultProductListingPage",
        query: DefaultProductListingPageQuery,
        variables: {
            url: categoryUrl
        }
    }), 1), defaultPlpContent = ref6[0];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "TopContentSlotPLP",
        query: TopContentSlotPLPQuery,
        variables: {
            url: categoryUrl
        }
    }), 1), topPlpContent = ref7[0];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "BottomContentSlotPLP",
        query: BottomContentSlotPLPQuery,
        variables: {
            url: categoryUrl
        }
    }), 1), bottomPlpContent = ref8[0];
    var pageContent = (0,_object_spread/* default */.Z)({}, defaultPlpContent === null || defaultPlpContent === void 0 ? void 0 : (ref = defaultPlpContent.data) === null || ref === void 0 ? void 0 : ref.content, topPlpContent === null || topPlpContent === void 0 ? void 0 : (ref1 = topPlpContent.data) === null || ref1 === void 0 ? void 0 : ref1.content, bottomPlpContent === null || bottomPlpContent === void 0 ? void 0 : (ref2 = bottomPlpContent.data) === null || ref2 === void 0 ? void 0 : ref2.content);
    var ref9 = pageContent || {}, recommenderId = ref9.recommenderId, recommenderEnabled = ref9.recommenderEnabled, topContent = ref9.topContent, bottomContent = ref9.bottomContent, bottomSeoContent = ref9.bottomSeoContent, localeBottomSeoContent = ref9.localeBottomSeoContent, tiles = ref9.tiles, seo = ref9.seo, pageContentId = ref9._id, relatedLinks = ref9.relatedLinks;
    // ___________________ Product Recomender ___________________________
    var shouldRecommendProducts = recommenderEnabled && !!recommenderId;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useRecommendationsWithDetailsQuery */.MA5)({
        variables: {
            pageType: recommenderId,
            ids: (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id) ? [
                currentCategory.id
            ] : []
        },
        pause: isServer || !shouldRecommendProducts || !(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id)
    }), 1), recommenderResult = ref10[0];
    var ref11;
    var recommendations = (ref11 = (ref3 = recommenderResult.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.recommendationsWithDetails) === null || ref4 === void 0 ? void 0 : ref4.recommendations) !== null && ref11 !== void 0 ? ref11 : [];
    var filteredRecommendations = recommendations.filter(function(x) {
        return (x === null || x === void 0 ? void 0 : x.__typename) === "ProductSearchHit";
    });
    var shouldDisplayRecommenderRow = shouldRecommendProducts && recommendations.length && !hasActiveFilter && !hasExplicitSort;
    var recommended = shouldDisplayRecommenderRow ? filteredRecommendations === null || filteredRecommendations === void 0 ? void 0 : filteredRecommendations.slice(0, 4) : [];
    var recommendationsWithDetails = (ref5 = recommenderResult.data) === null || ref5 === void 0 ? void 0 : ref5.recommendationsWithDetails;
    var recommenderName = recommendationsWithDetails === null || recommendationsWithDetails === void 0 ? void 0 : recommendationsWithDetails.recommenderName;
    return {
        recommenderId: recommenderId,
        recommenderEnabled: recommenderEnabled,
        topContent: topContent,
        bottomContent: bottomContent,
        bottomSeoContent: bottomSeoContent,
        localeBottomSeoContent: localeBottomSeoContent,
        tiles: tiles,
        seo: seo,
        recommended: recommended,
        recommendationsWithDetails: recommendationsWithDetails,
        recommenderName: recommenderName,
        pageContentId: pageContentId,
        relatedLinks: relatedLinks
    };
};

// EXTERNAL MODULE: ./utils/categoryNameFromUrl.ts
var categoryNameFromUrl = __webpack_require__(67665);
// EXTERNAL MODULE: ./utils/buildProductUrl.ts
var buildProductUrl = __webpack_require__(69377);
// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var utils_locale = __webpack_require__(79302);
;// CONCATENATED MODULE: ./utils/itemListSchema.ts


function itemListSchema(products, currency, host, countryCode, language) {
    var getProductUrl = function(product) {
        var ref, ref1, ref2, ref3;
        var id = (ref = product.masterProduct) === null || ref === void 0 ? void 0 : ref.id;
        var name = ((ref1 = product.variantProduct) === null || ref1 === void 0 ? void 0 : ref1.name) || ((ref2 = product.masterProduct) === null || ref2 === void 0 ? void 0 : ref2.name) || "";
        var color = ((ref3 = product.variantProduct) === null || ref3 === void 0 ? void 0 : ref3.colorValue) || "";
        var hostUrl = host.startsWith("localhost") ? "http://".concat(host, "/") : "https://".concat(host, "/");
        var mappedCountryCode = (0,utils_locale/* getMappedCountryCode */.p5)(countryCode) || countryCode.toLowerCase();
        var locale = "".concat(mappedCountryCode, "/").concat(language);
        return "".concat(hostUrl).concat(locale).concat((0,buildProductUrl/* buildProductUrl */.B)(id !== null && id !== void 0 ? id : "", name, {
            color: color
        }));
    };
    return JSON.stringify({
        "@context": "http://schema.org",
        "@type": "ItemList",
        itemListElement: products.filter(function(product) {
            var masterProduct = product.masterProduct;
            var variantProduct = product.variantProduct;
            return masterProduct && variantProduct && ((variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.price) || (variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.salePrice)) && ((variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.name) || (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name));
        }).map(function(product, index) {
            var ref;
            var masterProduct = product.masterProduct;
            var variantProduct = product.variantProduct;
            return {
                "@type": "ListItem",
                position: index + 1,
                item: {
                    "@type": "Product",
                    image: (variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.preview) || ((ref = masterProduct.image) === null || ref === void 0 ? void 0 : ref.href),
                    name: (variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.name) || masterProduct.name || "",
                    url: getProductUrl(product),
                    brand: {
                        "@type": "Brand",
                        name: "PUMA"
                    },
                    offers: {
                        "@type": "Offer",
                        price: (variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.salePrice) || (variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.price),
                        priceCurrency: currency.code,
                        availability: "http://schema.org/InStock"
                    }
                }
            };
        })
    });
}

// EXTERNAL MODULE: ./ui/elements/InjectedScript.tsx
var InjectedScript = __webpack_require__(19735);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ./hooks/useResizeObserver.ts
var useResizeObserver = __webpack_require__(13765);
// EXTERNAL MODULE: ./hooks/usePromotionView.ts
var usePromotionView = __webpack_require__(32736);
// EXTERNAL MODULE: ./ui/elements/Link.tsx
var Link = __webpack_require__(68302);
// EXTERNAL MODULE: ./ui/content/CallToActions.tsx + 1 modules
var CallToActions = __webpack_require__(85814);
// EXTERNAL MODULE: ./ui/elements/Markdown.tsx + 1 modules
var Markdown = __webpack_require__(41467);
// EXTERNAL MODULE: ./ui/components/VideoOrImage.tsx
var VideoOrImage = __webpack_require__(4692);
// EXTERNAL MODULE: ./hooks/useLinkResolver.ts
var useLinkResolver = __webpack_require__(13022);
;// CONCATENATED MODULE: ./ui/content/PromoTile.tsx













var flexFromVerticalAlignment = function(alignment) {
    return ({
        top: "start",
        middle: "center",
        bottom: "end"
    })[alignment];
};
var PromoTile = function(props) {
    var ref, ref1, ref2;
    var textColor = props.textColor || "#000000";
    var bgColor = props.backgroundColor || "transparent";
    var promoTileRef = (0,react.useRef)(null);
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var ref3 = (0,useResizeObserver/* useResizeObserver */.y)(promoTileRef), ref4 = ref3.ref, width = ref3.width;
    var fontSize = (0,twind.tw)(width <= 280 && "text-xl", width > 280 && width <= 360 && "text-2xl", width > 360 && width < 640 && "text-3xl", width >= 640 && "text-4xl");
    var additionalCtaClass = (0,useSiteConfig/* useSiteConfig */.N)().additionalCtaClass;
    var promotion_name = props.header || (props === null || props === void 0 ? void 0 : (ref = props.cta) === null || ref === void 0 ? void 0 : ref.title) || "";
    var gaTrackData = {
        id: ((ref1 = props.puid) === null || ref1 === void 0 ? void 0 : ref1.current) || "",
        name: promotion_name,
        creative: "promo-tile",
        campaign: ((ref2 = props.puid) === null || ref2 === void 0 ? void 0 : ref2.current) || "",
        position: ""
    };
    var promotion_id = props.id;
    var creative_name = props._type || "PromoTile";
    var extendedGaTrackData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gaTrackData), {
        promotion_id: promotion_id,
        creative_name: creative_name,
        cta_links: props.cta ? [
            getLink(props.cta)
        ] : []
    });
    var ref5 = (0,usePromotionView/* usePromotionView */.Y)(ref4, extendedGaTrackData), promotionTrackerPosition = ref5.promotionTrackerPosition, ga4PromotionTrackerPosition = ref5.ga4PromotionTrackerPosition;
    if (promotionTrackerPosition) {
        gaTrackData.position = promotionTrackerPosition;
    }
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        link_url: getLink(props.cta),
        cta_click: undefined
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: promoTileRef,
        className: (0,twind.tw)("bg-[".concat(bgColor, "]"), "relative flex flex-col flex-none w-full h-full", "justify-".concat(flexFromVerticalAlignment(props.verticalAlignment))),
        "data-test-id": "stylitics-promo-tile",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,twind.tw)(!props.contentBelow ? "absolute inset-0" : "relative w-full h-full flex-grow"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoOrImage/* VideoOrImage */.X, {
                    image: props.backgroundImage,
                    header: props.header,
                    video: props.video,
                    mobileImage: props.mobileBackgroundImage
                })
            }),
            props.cta && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                query: props.cta.query,
                newtab: !!props.cta.newtab,
                href: getLink(props.cta),
                className: "absolute inset-0 h-full w-full",
                "aria-hidden": true,
                tabIndex: -1,
                gaBannerData: gaTrackData,
                ga4Data: ga4Data
            }),
            (props.header || props.copy || props.cta) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,twind.tw)("relative p-6 text-center w-full flex flex-col items-center text-[".concat(textColor, "]"), props.contentBelow && "mt-4"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: fontSize,
                        children: [
                            props.header && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "font-bold text-[1em] leading-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                    content: props.header
                                })
                            }),
                            props.copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-3 font-bold text-[0.62em] leading-snug",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                    content: props.copy
                                })
                            })
                        ]
                    }),
                    props.cta && props.cta.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                            ctas: [
                                props.cta
                            ],
                            className: additionalCtaClass !== null && additionalCtaClass !== void 0 ? additionalCtaClass : "",
                            gaBannerData: gaTrackData,
                            ga4Data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ga4Data), {
                                cta_click: props.cta.title || ""
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./utils/productLists.ts

var splicePromoTiles = function(products, promoTiles) {
    var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!promoTiles.length) return products;
    var items = (0,_to_consumable_array/* default */.Z)(products);
    var validPromoTiles = (0,_to_consumable_array/* default */.Z)(promoTiles);
    // if not on the first page, we need to eliminate the promo
    // tiles which would have been placed on previous pages
    var firstValidPosition = offset + 1;
    if (offset > 0) {
        var placeholderItems = new Array(offset).fill("-");
        var previousItems = splicePromoTiles(placeholderItems, promoTiles, 0);
        firstValidPosition = previousItems.length + 1;
    }
    // we then need to determine the expected number of items would result for the
    // current page
    var expectedResultLength = items.length;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = validPromoTiles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tile = _step.value;
            if (tile.position >= firstValidPosition && tile.position <= firstValidPosition + expectedResultLength) expectedResultLength += 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // we then need to only consider the promo which would be valid for the
    // current range
    var applicablePromoTiles = validPromoTiles.filter(function(x) {
        return x.position >= firstValidPosition && x.position < firstValidPosition + expectedResultLength;
    });
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = applicablePromoTiles[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var tile1 = _step1.value;
            var idx = tile1.position - firstValidPosition;
            items.splice(idx, 0, tile1);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return items;
};
var getPromoTiles = function(products, tiles, offset) {
    var productsWithVariant = products === null || products === void 0 ? void 0 : products.filter(function(p) {
        return p.variantProduct;
    });
    return splicePromoTiles(productsWithVariant, tiles || [], offset);
};

// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./utils/isNotNullish.ts
var isNotNullish = __webpack_require__(50597);
// EXTERNAL MODULE: ./hooks/useAnalyticsEventAfterPageviewEventHasFired.ts
var useAnalyticsEventAfterPageviewEventHasFired = __webpack_require__(9726);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
;// CONCATENATED MODULE: ./hooks/useProductListAnalytics.ts






var useProductListAnalytics = function(param) {
    var _filters = param.filters, filters = _filters === void 0 ? [] : _filters, sort = param.sort, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, products = param.products, list = param.list, categoryId = param.categoryId, itemListId = param.itemListId, itemListName = param.itemListName, itemIdEp = param.itemIdEp, itemNameEp = param.itemNameEp, items = param.items, search = param.search;
    var hasFilters = !!sort || filters.length > 0;
    var serializedFilters = JSON.stringify({
        filters: filters,
        sort: sort
    });
    var PRODUCT_LIST_UPDATED_EVENT_NAME = "".concat(analytics/* AnalyticsEvents.PRODUCT_LIST_UPDATED */._q.PRODUCT_LIST_UPDATED, "_").concat(offset);
    var PRODUCT_LIST_REFRESHED_EVENT_NAME = "".concat(analytics/* AnalyticsEvents.PRODUCT_LIST_REFRESHED */._q.PRODUCT_LIST_REFRESHED, "_").concat(serializedFilters);
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var ref = (0,usePageEventsContext/* usePageEventsContext */.qN)(), setEventFired = ref.setEventFired, setEventNotFired = ref.setEventNotFired, eventHasFired = ref.eventHasFired;
    var clearPageUpdatedEvents = function() {
        setEventNotFired(new RegExp("".concat(analytics/* AnalyticsEvents.PRODUCT_LIST_UPDATED */._q.PRODUCT_LIST_UPDATED, "_.*")));
    };
    var fireEvent = function(eventName) {
        (0,analytics/* event */.B)(eventName, {
            ecommerce: {
                currencyCode: currency.code,
                impressions: (products !== null && products !== void 0 ? products : []).map(function(product, idx) {
                    return (0,analytics/* transformListProductToAnalyticsProduct */.ve)(product, offset + idx, list, categoryId);
                }).filter(isNotNullish/* isNotNullish */.l)
            }
        });
        // NOTE: only fire event if there are items to display
        if (items && items.length > 0) {
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4EC_ItemListView */._q.GA4EC_ItemListView, {
                event_name: analytics/* AnalyticsEvents.VIEW_ITEM_LIST */._q.VIEW_ITEM_LIST,
                ecommerce: {
                    item_list_id: search ? search : itemListId,
                    item_list_name: search ? search : itemListName,
                    item_id_ep: itemIdEp,
                    item_name_ep: itemNameEp,
                    items: items
                }
            });
        }
    };
    // the logic here may seem convoluted, but the expectation is that:
    //
    // * AnalyticsEvents.PRODUCT_LIST_LOADED is fired when a PLP is first loaded (but only after the pageview event has fired)
    // * AnalyticsEvents.PRODUCT_LIST_UPDATED is fired when a new page of products is loaded
    // * AnalyticsEvents.PRODUCT_LIST_REFRESHED is fired when the filters or sort order are changed
    (0,useAnalyticsEventAfterPageviewEventHasFired/* useAnalyticsEventAfterPageviewEventHasFired */.T)(function() {
        if (!products) return;
        if (offset === 0) {
            // page one of results
            if (!eventHasFired(analytics/* AnalyticsEvents.PRODUCT_LIST_LOADED */._q.PRODUCT_LIST_LOADED)) {
                // this is the first load of the PLP
                fireEvent(analytics/* AnalyticsEvents.PRODUCT_LIST_LOADED */._q.PRODUCT_LIST_LOADED);
                setEventFired(analytics/* AnalyticsEvents.PRODUCT_LIST_LOADED */._q.PRODUCT_LIST_LOADED);
            }
        }
    }, [
        products,
        offset
    ]);
    (0,react.useEffect)(function() {
        if (!products) return;
        if (offset === 0 && hasFilters && !eventHasFired(PRODUCT_LIST_REFRESHED_EVENT_NAME)) {
            // this is a reload of the PLP with filters that have not been chosen before
            fireEvent(analytics/* AnalyticsEvents.PRODUCT_LIST_REFRESHED */._q.PRODUCT_LIST_REFRESHED);
            setEventFired(PRODUCT_LIST_REFRESHED_EVENT_NAME);
            clearPageUpdatedEvents();
        } else if (offset > 0 && !eventHasFired(PRODUCT_LIST_UPDATED_EVENT_NAME)) {
            // this is page two or greater, meaning loading more products
            fireEvent(analytics/* AnalyticsEvents.PRODUCT_LIST_UPDATED */._q.PRODUCT_LIST_UPDATED);
            setEventFired(PRODUCT_LIST_UPDATED_EVENT_NAME);
        }
    }, [
        products,
        offset,
        serializedFilters
    ]); // eslint-disable-line react-hooks/exhaustive-deps
};

// EXTERNAL MODULE: ./ui/components/LoadMore.tsx
var LoadMore = __webpack_require__(79892);
;// CONCATENATED MODULE: ./ui/components/PaginatedProductListPage.tsx


















var PaginatedProductListPage = function(param) {
    var offset = param.offset, tiles = param.tiles, isLast = param.isLast, totalProducts = param.totalProducts, query = param.query, productsRef = param.productsRef, allProductsRef = param.allProductsRef, handleIntersection = param.handleIntersection, setListProducts = param.setListProducts, isFirst = param.isFirst, isCompactMode = param.isCompactMode;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var router = (0,next_router.useRouter)();
    var category = router.query.category;
    var categoryUrl = (0,getUrlByCategory/* getUrlByCategory */.M)(category);
    var ref17 = (0,useSiteConfig/* useSiteConfig */.N)(), currency = ref17.currency, host = ref17.host, countryCode = ref17.country, language = ref17.language;
    var ref18 = (0,_sliced_to_array/* default */.Z)(useCategoryPLPQuery({
        pause: query !== null,
        router: router,
        offset: offset,
        includeMetadata: offset === 0,
        url: categoryUrl,
        preview: (0,getPreviewInput/* getPreviewInput */.T)(router.query)
    }), 1), minimalPaginatedQuery = ref18[0];
    var currentQuery = query !== null && query !== void 0 ? query : minimalPaginatedQuery;
    var products = react.useMemo(function() {
        var ref, ref1;
        return (currentQuery === null || currentQuery === void 0 ? void 0 : (ref = currentQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.categoryByUrl) === null || ref1 === void 0 ? void 0 : ref1.products.nodes.filter(function(param) {
            var masterProduct = param.masterProduct;
            return masterProduct !== null;
        })) || [];
    }, [
        currentQuery === null || currentQuery === void 0 ? void 0 : (ref = currentQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.categoryByUrl) === null || ref1 === void 0 ? void 0 : ref1.products.nodes
    ]);
    var prevProductsRef = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        var newProducts = products.filter(function(product) {
            return !prevProductsRef.current.some(function(p) {
                var ref, ref1;
                return (p === null || p === void 0 ? void 0 : (ref = p.variantProduct) === null || ref === void 0 ? void 0 : ref.id) === (product === null || product === void 0 ? void 0 : (ref1 = product.variantProduct) === null || ref1 === void 0 ? void 0 : ref1.id);
            });
        });
        if (newProducts.length > 0) {
            setListProducts(function(prevProducts) {
                var updatedProducts = (0,_to_consumable_array/* default */.Z)(prevProducts).concat((0,_to_consumable_array/* default */.Z)(newProducts));
                prevProductsRef.current = updatedProducts;
                return updatedProducts;
            });
        }
    }, [
        products,
        setListProducts
    ]);
    var currentCategory = (ref2 = currentQuery.data) === null || ref2 === void 0 ? void 0 : ref2.categoryByUrl;
    useProductListAnalytics({
        offset: offset,
        filters: currentQuery === null || currentQuery === void 0 ? void 0 : (ref3 = currentQuery.operation) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variables) === null || ref4 === void 0 ? void 0 : ref4.filters,
        sort: currentQuery === null || currentQuery === void 0 ? void 0 : (ref5 = currentQuery.operation) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.variables) === null || ref6 === void 0 ? void 0 : ref6.sort,
        products: currentQuery === null || currentQuery === void 0 ? void 0 : (ref7 = currentQuery.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.categoryByUrl) === null || ref8 === void 0 ? void 0 : ref8.products.nodes,
        list: currentQuery === null || currentQuery === void 0 ? void 0 : (ref9 = currentQuery.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.categoryByUrl) === null || ref10 === void 0 ? void 0 : ref10.url,
        categoryId: currentQuery === null || currentQuery === void 0 ? void 0 : (ref11 = currentQuery.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.categoryByUrl) === null || ref12 === void 0 ? void 0 : ref12.id,
        itemListId: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id,
        itemListName: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name
    });
    var listTiles = react.useMemo(function() {
        return getPromoTiles(products, tiles || [], offset);
    }, [
        products,
        tiles,
        offset
    ]);
    (0,react.useEffect)(function() {
        var options = {
            root: null,
            rootMargin: "1px",
            threshold: 0.5
        };
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var productId = entry.target.getAttribute("data-product-id");
                    var dataTestId = entry.target.getAttribute("data-test-id");
                    handleIntersection(productId || dataTestId);
                }
            });
        }, options);
        document.querySelectorAll('[data-test-id="product-list-item"]').forEach(function(item) {
            return observer.observe(item);
        });
        var styliticsPromoTile = document.querySelector('[data-test-id="positioned-promo-tile"]');
        if (styliticsPromoTile) observer.observe(styliticsPromoTile);
        return function() {
            observer.disconnect();
        };
    }, [
        handleIntersection,
        productsRef,
        allProductsRef
    ]);
    var ref19 = (0,react.useState)(null), dimensions = ref19[0], setDimensions = ref19[1];
    var handleDimensionsChange = function(width, height) {
        setDimensions({
            width: width,
            height: height
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !currentQuery.fetching && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isFirst && (products === null || products === void 0 ? void 0 : products.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                        type: "application/ld+json",
                        script: itemListSchema(products, currency, host, countryCode, language)
                    }),
                    listTiles.map(function(item, idx) {
                        var key = "".concat(item.id, "_").concat(idx);
                        if (item.__typename === "ProductSearchHit") {
                            var ref, ref1;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItem/* ProductListItem */.A, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                disableRatings: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.disableRatings
                            }, item), {
                                position: offset + idx + 1,
                                categoryId: (ref = currentQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.categoryByUrl) === null || ref1 === void 0 ? void 0 : ref1.id,
                                itemListId: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id,
                                itemListName: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name,
                                onDimensionsChange: handleDimensionsChange,
                                isCompactMode: isCompactMode
                            }), key);
                        } else if (item._type === "tileWithPosition") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "relative pt-72 xs:pt-96",
                                "data-test-id": "positioned-promo-tile",
                                style: {
                                    width: dimensions === null || dimensions === void 0 ? void 0 : dimensions.width,
                                    height: dimensions === null || dimensions === void 0 ? void 0 : dimensions.height
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute inset-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoTile, (0,_object_spread/* default */.Z)({}, item.tile))
                                })
                            }, key);
                        }
                        return null;
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadMore/* LoadMore */.f, {
                fetching: currentQuery.fetching,
                isLastPageCurrentlyDisplayed: isLast,
                totalCount: totalProducts,
                itemListId: currentQuery === null || currentQuery === void 0 ? void 0 : (ref13 = currentQuery.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.categoryByUrl) === null || ref14 === void 0 ? void 0 : ref14.id,
                itemListName: currentQuery === null || currentQuery === void 0 ? void 0 : (ref15 = currentQuery.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.categoryByUrl) === null || ref16 === void 0 ? void 0 : ref16.name
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useEmarsysWebExtend.tsx + 2 modules
var useEmarsysWebExtend = __webpack_require__(78108);
// EXTERNAL MODULE: ./hooks/useScreenSize.ts
var useScreenSize = __webpack_require__(32629);
// EXTERNAL MODULE: ./hooks/useGetRecommenderLocation.tsx
var useGetRecommenderLocation = __webpack_require__(16666);
;// CONCATENATED MODULE: ./ui/pages/ProductListingPage/hooks/usePlpEventTracking.tsx







var usePlpEventTracking = function(param) {
    var categoryPath = param.categoryPath, currentCategory = param.currentCategory, isPlpFetching = param.isPlpFetching, offset = param.offset, recommenderName = param.recommenderName;
    var intersectedProductsRef = (0,react.useRef)([]);
    var intersectAllProductsRef = (0,react.useRef)([]);
    var ref = (0,react.useState)([]), listProducts = ref[0], setListProducts = ref[1];
    var screenSize = (0,useScreenSize/* useScreenSize */.e)();
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var trackCategory = (0,useEmarsysWebExtend/* useEmarsysWebExtend */._)().trackCategory;
    var isFromRedirect = (0,react.useCallback)(function() {
        return window.sessionStorage.getItem("user_action") === "redirect";
    }, []);
    var totalCount = currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.products.totalCount;
    var recommenderLocation = (0,useGetRecommenderLocation/* useGetRecommenderLocation */.g)();
    (0,react.useEffect)(function() {
        // When query has finished and has data we trigger the event.
        if (isPlpFetching || !currentCategory) return;
        trackCategory(categoryPath.map(function(x) {
            return x.label;
        }));
    }, [
        categoryPath,
        trackCategory,
        currentCategory,
        isPlpFetching
    ]);
    (0,react.useEffect)(function() {
        // When query has finished and user has searched
        if (!isPlpFetching && isFromRedirect()) (0,analytics/* searchAnalyticsEvent */.dr)(String(totalCount));
    }, [
        totalCount,
        isPlpFetching,
        isFromRedirect
    ]);
    (0,react.useEffect)(function() {
        return function() {
            window.sessionStorage.removeItem("last-clicked-promotion");
        };
    }, []);
    (0,react.useEffect)(function() {
        if (recommenderName) {
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PRODUCT_RECOMMENDER_VIEWED */._q.PRODUCT_RECOMMENDER_VIEWED, {
                ecommerce: {
                    productRecommenderLocation: recommenderLocation(),
                    recommenderName: recommenderName
                }
            });
        }
    }, [
        recommenderLocation,
        recommenderName
    ]);
    var handleIntersection = (0,react.useCallback)(function(productId) {
        var storedPromotion = window.sessionStorage.getItem("last-clicked-promotion");
        var promotion = storedPromotion !== null ? JSON.parse(storedPromotion) : undefined;
        (0,analytics/* handleIntersectionPLP */.RQ)({
            productId: productId,
            intersectedProductsRef: intersectedProductsRef,
            intersectAllProductsRef: intersectAllProductsRef,
            listProducts: listProducts,
            screenSize: screenSize,
            currency: currency,
            offset: offset,
            pageviewEventHasFired: pageviewEventHasFired,
            currentCategory: currentCategory,
            promotion: promotion
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        listProducts,
        screenSize,
        pageviewEventHasFired
    ]);
    return {
        handleIntersection: handleIntersection,
        setListProducts: setListProducts,
        intersectedProductsRef: intersectedProductsRef,
        intersectAllProductsRef: intersectAllProductsRef
    };
};

;// CONCATENATED MODULE: ./ui/pages/ProductListingPage/components/CrawlersPagination.tsx









var CrawlersPagination = function(param) {
    var totalProductsCount = param.totalProductsCount;
    var router = (0,next_router.useRouter)();
    var host = (0,useSiteConfig/* useSiteConfig */.N)().host;
    var isCrawler = (0,useIsCrawler/* useIsCrawler */.i)();
    var pageParam = router.query.page;
    var serverPage = Number(pageParam) > 1 ? Number(pageParam) : 1;
    var prevPage = serverPage > 2 ? serverPage - 1 : 1;
    var nextPage = serverPage + 1;
    var isFinalPageOfResults = serverPage * utils_products/* MAX_PRODUCT_PAGE_SIZE */.ur >= totalProductsCount;
    var ref = (0,_sliced_to_array/* default */.Z)(router.asPath.split("?"), 1), pathname = ref[0];
    var protocol = host.startsWith("localhost") ? "http://" : "https://";
    (0,react.useEffect)(function() {
        var ref;
        if (pageParam && !Boolean(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.offset)) {
            var offset = (serverPage - 1) * utils_products/* MAX_PRODUCT_PAGE_SIZE */.ur;
            router.replace({
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    offset: offset
                })
            }, "", {
                scroll: false
            });
        }
    }, [
        pageParam,
        router,
        serverPage
    ]);
    if (!isCrawler) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-puma-black text-base",
        "data-test-id": "crawlers-pagination",
        children: [
            serverPage > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "".concat(protocol).concat(host).concat(pathname).concat(serverPage === 2 ? "" : "?page=".concat(prevPage)),
                className: "mr-1",
                children: "Previous"
            }),
            !isFinalPageOfResults && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "".concat(protocol).concat(host).concat(pathname, "?page=").concat(nextPage),
                children: "Next"
            })
        ]
    });
};
/* harmony default export */ var components_CrawlersPagination = (CrawlersPagination);

;// CONCATENATED MODULE: ./ui/pages/ProductListingPage/ProductListingPage.tsx





































var ProductListingPage = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref11 = (0,useSiteConfig/* useSiteConfig */.N)(), isPNARegion = ref11.staticFeatures.isPNARegion;
    var isCrawler = (0,useIsCrawler/* useIsCrawler */.i)();
    var desiredCategory = router.query.category;
    var categoryUrl = (0,getUrlByCategory/* getUrlByCategory */.M)(desiredCategory);
    var ref12 = (0,_sliced_to_array/* default */.Z)(useCategoryPLPQuery({
        router: router,
        offset: 0,
        includeMetadata: true,
        url: categoryUrl,
        src: router.query.src,
        preview: (0,getPreviewInput/* getPreviewInput */.T)(router.query)
    }), 2), query = ref12[0], refetch = ref12[1];
    var isPLPref = (0,useHeading/* useHeading */.h)().isPLPref;
    if (isPLPref) {
        isPLPref.current = true;
    }
    var categoryGeneralId = (ref = query.data) === null || ref === void 0 ? void 0 : (ref1 = ref.categoryByUrl) === null || ref1 === void 0 ? void 0 : ref1.id;
    (0,react.useEffect)(function() {
        // Refetch this query on the client within the context of a customer if:
        // 1. is the first render after SSR.
        // 2. user is not a crawler (we've inferred some important queries are being blocked in CSR as in GSC returns a 404 not found page -
        // we add this condition to prevent updating data if user is a Crawler).
        var shouldRefetch = (0,isInitialClientRender/* isInitialClientRender */.R)(router) && !isCrawler;
        if (shouldRefetch) {
            refetch({
                requestPolicy: "cache-and-network"
            });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var currentCategory = (ref2 = query.data) === null || ref2 === void 0 ? void 0 : ref2.categoryByUrl;
    var categoryPath = (0,react.useMemo)(function() {
        return (0,constructCategoryPath/* constructCategoryPath */.h)(currentCategory);
    }, [
        currentCategory
    ]);
    var _totalCount;
    var totalCount = (_totalCount = currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.products.totalCount) !== null && _totalCount !== void 0 ? _totalCount : 0;
    var path = (0,react.useMemo)(function() {
        return (0,breadcrumbRedirects/* createCategoryPageBreadcrumbLinks */.hH)(currentCategory);
    }, [
        currentCategory
    ]);
    var pageParam = router.query.page;
    var serverPage = Number(pageParam) > 1 ? Number(pageParam) : 1;
    var hasActiveFilter = !!((ref3 = query.operation) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variables) === null || ref4 === void 0 ? void 0 : ref4.filters.length);
    var hasExplicitSort = !!((ref5 = query.operation) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.variables) === null || ref6 === void 0 ? void 0 : ref6.sort);
    var ref13 = usePLPContent(categoryUrl, currentCategory, hasActiveFilter, hasExplicitSort), topContent = ref13.topContent, bottomContent = ref13.bottomContent, bottomSeoContent = ref13.bottomSeoContent, localeBottomSeoContent = ref13.localeBottomSeoContent, tiles = ref13.tiles, seo = ref13.seo, recommended = ref13.recommended, recommendationsWithDetails = ref13.recommendationsWithDetails, pageContentId = ref13.pageContentId, recommenderName = ref13.recommenderName, relatedLinks = ref13.relatedLinks;
    var bottomSeoContentData = localeBottomSeoContent || bottomSeoContent;
    var queryOffset = Number(router.query.offset) || 0;
    var offset = totalCount && queryOffset >= totalCount ? totalCount - utils_products/* MAX_PRODUCT_PAGE_SIZE */.ur : queryOffset;
    var numberOfPages = pageParam && !offset ? serverPage * utils_products/* MAX_PRODUCT_PAGE_SIZE */.ur >= totalCount ? Math.ceil(totalCount / utils_products/* MAX_PRODUCT_PAGE_SIZE */.ur) : serverPage : Math.ceil(offset / utils_products/* MAX_PRODUCT_PAGE_SIZE */.ur) + 1;
    var pages = new Array(numberOfPages).fill(null);
    var _totalCount1;
    var totalProductsCount = (_totalCount1 = currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.products.totalCount) !== null && _totalCount1 !== void 0 ? _totalCount1 : 0;
    var totalCountToShow = totalProductsCount + recommended.length;
    var showLoadingIndicator = "/" + desiredCategory.join("/") !== (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.url) && !query.fetching || offset !== 0 && query.fetching && !query.data;
    var ref14 = (0,react.useState)(false), isCompactMode = ref14[0], setIsCompactMode = ref14[1];
    var ref15 = usePlpEventTracking({
        categoryPath: categoryPath,
        currentCategory: currentCategory,
        isPlpFetching: query.fetching,
        offset: offset,
        recommenderName: recommenderName
    }), handleIntersection = ref15.handleIntersection, setListProducts = ref15.setListProducts, intersectedProductsRef = ref15.intersectedProductsRef, intersectAllProductsRef = ref15.intersectAllProductsRef;
    var indexValue = pageParam ? true : seo === null || seo === void 0 ? void 0 : seo.noIndex;
    var flagPNARecommended = isPNARegion && filterActivated(router.query);
    var categoryName = (0,categoryNameFromUrl/* categoryNameFromUrl */.S)(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.url);
    var ref16;
    var title = ((seo === null || seo === void 0 ? void 0 : seo.pageTitle) ? seo.pageTitle : (ref16 = currentCategory === null || currentCategory === void 0 ? void 0 : (ref7 = currentCategory.seo) === null || ref7 === void 0 ? void 0 : ref7.pageTitle) !== null && ref16 !== void 0 ? ref16 : t("pageTitle", {
        title: ""
    })) || (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.title) || (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name);
    var ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* PageHead */.y, {
                title: title,
                description: (seo === null || seo === void 0 ? void 0 : seo.pageDescription) ? seo.pageDescription : (ref17 = currentCategory === null || currentCategory === void 0 ? void 0 : (ref8 = currentCategory.seo) === null || ref8 === void 0 ? void 0 : ref8.pageDescription) !== null && ref17 !== void 0 ? ref17 : "",
                openGraphDescription: (ref18 = seo === null || seo === void 0 ? void 0 : seo.openGraphDescription) !== null && ref18 !== void 0 ? ref18 : "",
                openGraphImageUrl: (ref19 = seo === null || seo === void 0 ? void 0 : seo.openGraphImageUrl) !== null && ref19 !== void 0 ? ref19 : "",
                openGraphTitle: (ref20 = seo === null || seo === void 0 ? void 0 : seo.openGraphTitle) !== null && ref20 !== void 0 ? ref20 : "",
                openGraphType: (ref21 = seo === null || seo === void 0 ? void 0 : seo.openGraphType) !== null && ref21 !== void 0 ? ref21 : "",
                openGraphVideoUrl: (ref22 = seo === null || seo === void 0 ? void 0 : seo.openGraphVideoUrl) !== null && ref22 !== void 0 ? ref22 : "",
                twitterDescription: (ref23 = seo === null || seo === void 0 ? void 0 : seo.twitterDescription) !== null && ref23 !== void 0 ? ref23 : "",
                twitterImageUrl: (ref24 = seo === null || seo === void 0 ? void 0 : seo.twitterImageUrl) !== null && ref24 !== void 0 ? ref24 : "",
                twitterTitle: (ref25 = seo === null || seo === void 0 ? void 0 : seo.twitterTitle) !== null && ref25 !== void 0 ? ref25 : "",
                noIndex: indexValue,
                noIndexFollow: indexValue,
                noHreflangs: hardcodedHreflangs/* availablePages.includes */.y.includes(categoryGeneralId || "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hreflangs/* Hreflangs */.k, {
                id: categoryGeneralId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* Page */.T, {
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                    fetching: showLoadingIndicator
                }),
                emarsysData: {
                    skipTracking: false
                },
                bloomreachData: {
                    cat: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name,
                    cat_id: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductListFilterProvider/* ProductListFilterProvider */.w, {
                        isFetching: query.fetching,
                        noResults: totalCount === 0,
                        filteringOptions: (currentCategory === null || currentCategory === void 0 ? void 0 : (ref9 = currentCategory.products) === null || ref9 === void 0 ? void 0 : ref9.filteringOptions) || [],
                        sortingOptions: (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.products.sortingOptions) || [],
                        defaultSortOption: (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.products.selectedSort) || "",
                        totalCount: totalCountToShow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* Breadcrumb */.a, {
                                path: path
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                                items: topContent,
                                slotId: "topContent",
                                documentId: pageContentId
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                                className: "text-2xl md:text-3xl lg:text-4xl xl:text-4xl uppercase font-bold",
                                dataTestId: "product-results",
                                tag: "h1",
                                mainHeading: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.title) || (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name) || categoryName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductList/* ProductList */.c, {
                                isFetching: query.fetching,
                                noResults: totalCount === 0,
                                filteringOptions: (currentCategory === null || currentCategory === void 0 ? void 0 : (ref10 = currentCategory.products) === null || ref10 === void 0 ? void 0 : ref10.filteringOptions) || [],
                                sortingOptions: (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.products.sortingOptions) || [],
                                defaultSortOption: (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.products.selectedSort) || "",
                                totalCount: totalCountToShow,
                                handleCompactMode: setIsCompactMode,
                                children: [
                                    !flagPNARecommended && (recommended === null || recommended === void 0 ? void 0 : recommended.map(function(p, i) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductListItem/* ProductListItem */.A, (0,_object_spread/* default */.Z)({
                                            position: offset + i + 1,
                                            categoryId: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id,
                                            fromRecommender: recommendationsWithDetails,
                                            itemListId: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id,
                                            itemListName: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name
                                        }, p), p.id);
                                    })),
                                    pages.map(function(_, i) {
                                        var isFirstPage = i === 0;
                                        var isLastPage = i === pages.length - 1;
                                        return !pageParam || pageParam && i >= serverPage - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginatedProductListPage, {
                                            isFirst: isFirstPage && !pageParam || serverPage - 1 === i,
                                            isLast: isLastPage,
                                            totalProducts: totalCount,
                                            offset: i * utils_products/* MAX_PRODUCT_PAGE_SIZE */.ur,
                                            tiles: tiles,
                                            query: null,
                                            productsRef: intersectedProductsRef,
                                            allProductsRef: intersectAllProductsRef,
                                            handleIntersection: handleIntersection,
                                            setListProducts: setListProducts,
                                            isCompactMode: isCompactMode
                                        }, i) : null;
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-6 md:mb-8",
                                children: (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineReadMore, {
                                    className: "text-puma-black text-base",
                                    innerHtmlString: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.description
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CrawlersPagination, {
                                totalProductsCount: totalCount
                            }),
                            relatedLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedLinks, {
                                relatedLinks: relatedLinks
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                                items: bottomContent,
                                slotId: "bottomContent",
                                documentId: pageContentId
                            }),
                            bottomSeoContentData && /*#__PURE__*/ (0,jsx_runtime.jsx)(serializeBlockContent/* Prose */.Mr, {
                                content: bottomSeoContentData
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToTopButton/* ScrollToTopButton */.U, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/pages/ProductListingPage/index.ts
// Only exports ProductListingPage


// EXTERNAL MODULE: ./groq/queries/PageType.ts
var PageType = __webpack_require__(99550);
// EXTERNAL MODULE: ./utils/isContentOnline.ts
var isContentOnline = __webpack_require__(89996);
// EXTERNAL MODULE: ./groq/queries/MainFooterQuery.ts
var MainFooterQuery = __webpack_require__(83070);
// EXTERNAL MODULE: ./groq/documents/GlobalPromoBannerDocument.ts
var GlobalPromoBannerDocument = __webpack_require__(94735);
// EXTERNAL MODULE: ./groq/documents/SecondGlobalBannerDocument.ts
var SecondGlobalBannerDocument = __webpack_require__(63642);
// EXTERNAL MODULE: ./utils/getContentInputQuery.ts
var getContentInputQuery = __webpack_require__(52938);
;// CONCATENATED MODULE: ./pages/[country]/[language]/[...category]/index.tsx


























// This is a catch all entry point for all pages with a URL that
// doesn't match any other page type. It will check to see if there
// is a page type for the URL and if so render that page type.
var _category_Page = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var category = router.query.category;
    var url = (0,getUrlByCategory/* getUrlByCategory */.M)(category);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "PageType",
        query: PageType/* PageTypeQuery */.i,
        variables: {
            url: url
        }
    }), 1), pageType = ref1[0];
    var pageTypes = ((ref = pageType.data) === null || ref === void 0 ? void 0 : ref.content) || {};
    // When choosing which page type to render for a given URL we need to check documents
    // in order of priority. The first document that has an _id and is online will be rendered.
    var onlinePage = [
        "MarketingPage",
        "CategoryPage",
        "category"
    ].map(function(type) {
        return pageTypes[type];
    }).filter(function(doc) {
        return doc === null || doc === void 0 ? void 0 : doc._id;
    }).find(function(doc) {
        return (0,isContentOnline/* isContentOnline */.e)(doc, (0,useGroqQuery/* groqPreviewInput */.i8)(router.query));
    });
    if (pageType.fetching) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageLoadingSpinner */.v, {});
    switch(onlinePage === null || onlinePage === void 0 ? void 0 : onlinePage._type){
        case "MarketingPage":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingPage_MarketingPage, {});
        case "CategoryPage":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryPage_CategoryPage, {});
        case "category":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListingPage, {});
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSearchResults/* NoSearchResults */.qx, {});
    }
};
// Adding this excludes the following code from the client bundle however
// all static imports that the below code depends on will still be included
if (constants/* isServer */.sk) {
    _category_Page.getInitialProps = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(appContext) {
            var ref, context, res, client, pageType, _tmp, pageTypes, _tmp1, onlinePage, ref1, searchParams, stringifiedQueryParams, _tmp2, _tmp3, ref2, desiredCategory, categoryUrl, defaultProductListingPageQuery, _tmp4, topContentSlotPLPQuery, _tmp5, bottomContentSlotPLPQuery, _tmp6, globalPromoBannerQuery, _tmp7, secondGlobalBannerQuery, _tmp8, mainFooterQuery, _tmp9, categoryPLPQuery, _tmp10, _tmp11, promises, categoryPLPResult, currentCategory, breadcrumbLinks, redirectPromises, _tmp12;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        context = appContext;
                        res = context.res;
                        client = context.urqlClient;
                        _tmp = {};
                        return [
                            4,
                            client.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("PageType"), (_tmp.input = {
                                query: PageType/* PageTypeQuery.replace */.i.replace(/[\n]+/g, "").replace(/\s\s+/g, ""),
                                params: {
                                    url: "/".concat(context.query.category.join("/"))
                                },
                                src: context.query.src,
                                draft: context.query.draft,
                                preview: (0,useGroqQuery/* groqPreviewInput */.i8)(context.query)
                            }, _tmp)).toPromise()
                        ];
                    case 1:
                        pageType = _state.sent();
                        _tmp1 = {};
                        pageTypes = ((ref = pageType.data) === null || ref === void 0 ? void 0 : ref.content) || _tmp1;
                        onlinePage = [
                            "MarketingPage",
                            "CategoryPage",
                            "category"
                        ].map(function(type) {
                            return pageTypes[type];
                        }).filter(function(doc) {
                            return doc === null || doc === void 0 ? void 0 : doc._id;
                        }).find(function(doc) {
                            return (0,isContentOnline/* isContentOnline */.e)(doc, (0,useGroqQuery/* groqPreviewInput */.i8)(context.query));
                        });
                        _tmp2 = {};
                        _tmp3 = {};
                        if (context.query.offset && !context.query.page) {
                            ;
                            searchParams = new URLSearchParams(context.query);
                            searchParams.delete("offset");
                            searchParams.delete("country");
                            searchParams.delete("category");
                            searchParams.delete("language");
                            stringifiedQueryParams = searchParams.toString();
                            res.writeHead(308, (_tmp2.Location = "".concat(context === null || context === void 0 ? void 0 : (ref1 = context.asPath) === null || ref1 === void 0 ? void 0 : ref1.split("?")[0]).concat(stringifiedQueryParams && "?").concat(stringifiedQueryParams), _tmp2));
                            res.end();
                            return [
                                2,
                                _tmp3
                            ];
                        }
                        if (!onlinePage) res.statusCode = 404;
                        if (!((onlinePage === null || onlinePage === void 0 ? void 0 : onlinePage._type) === "category")) return [
                            3,
                            6
                        ];
                        desiredCategory = context.query.category;
                        categoryUrl = "/".concat(desiredCategory === null || desiredCategory === void 0 ? void 0 : desiredCategory.join("/"));
                        _tmp4 = {};
                        defaultProductListingPageQuery = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("DefaultProductListingPage"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp4.query = DefaultProductListingPageQuery, _tmp4.context = context, _tmp4.params = {
                            url: categoryUrl
                        }, _tmp4)));
                        _tmp5 = {};
                        topContentSlotPLPQuery = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("TopContentSlotPLP"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp5.query = TopContentSlotPLPQuery, _tmp5.context = context, _tmp5.params = {
                            url: categoryUrl
                        }, _tmp5)));
                        _tmp6 = {};
                        bottomContentSlotPLPQuery = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("BottomContentSlotPLP"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp6.query = BottomContentSlotPLPQuery, _tmp6.context = context, _tmp6.params = {
                            url: categoryUrl
                        }, _tmp6)));
                        _tmp7 = {};
                        globalPromoBannerQuery = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("GlobalPromoBanner"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp7.query = GlobalPromoBannerDocument/* GlobalPromoBannerDocument */.$, _tmp7.context = context, _tmp7)));
                        _tmp8 = {};
                        secondGlobalBannerQuery = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("SecondGlobalBanner"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp8.query = SecondGlobalBannerDocument/* SecondGlobalBannerDocument */.B, _tmp8.context = context, _tmp8)));
                        _tmp9 = {};
                        mainFooterQuery = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("MainFooter"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp9.query = MainFooterQuery/* MainFooterQuery */.Q, _tmp9.context = context, _tmp9)));
                        _tmp10 = {};
                        _tmp11 = {};
                        categoryPLPQuery = context.urqlClient.query(CATEGORY_PLP_QUERY, (0,_object_spread/* default */.Z)((_tmp10.url = categoryUrl, _tmp10.src = context.query.src, _tmp10.preview = (0,getPreviewInput/* getPreviewInput */.T)(context.query), _tmp10.includeCategoryMetadata = true, _tmp10), (0,queries_products/* commonQueryVariables */.J)((_tmp11.router = {
                            query: context.query
                        }, _tmp11.offset = 0, _tmp11))));
                        promises = [
                            defaultProductListingPageQuery,
                            topContentSlotPLPQuery,
                            bottomContentSlotPLPQuery,
                            categoryPLPQuery,
                            globalPromoBannerQuery,
                            secondGlobalBannerQuery,
                            mainFooterQuery
                        ];
                        return [
                            4,
                            categoryPLPQuery.toPromise()
                        ];
                    case 2:
                        categoryPLPResult = _state.sent();
                        currentCategory = (ref2 = categoryPLPResult.data) === null || ref2 === void 0 ? void 0 : ref2.categoryByUrl;
                        if (!currentCategory) return [
                            3,
                            4
                        ];
                        breadcrumbLinks = (0,breadcrumbRedirects/* createCategoryPageBreadcrumbLinks */.hH)(currentCategory);
                        redirectPromises = (0,breadcrumbRedirects/* fetchBreadcrumbRedirectPromises */.VD)(context.urqlClient, breadcrumbLinks);
                        return [
                            4,
                            Promise.all((0,_to_consumable_array/* default */.Z)(promises).concat((0,_to_consumable_array/* default */.Z)(redirectPromises)))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(promises)
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        _tmp12 = {};
                        // These props get inherited by any getInitialProps further up the render tree
                        // in this case that is _app but ultimately there are no props to pass up
                        // return an object that a non-empty to prevent "returned an empty object" error in logs
                        return [
                            2,
                            (_tmp12.emptyProps = true, _tmp12)
                        ];
                }
            });
        });
        return function(appContext) {
            return _ref.apply(this, arguments);
        };
    }();
}
/* harmony default export */ var _category_ = (_category_Page);


/***/ }),

/***/ 52938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getContentInputQuery; }
/* harmony export */ });
/* harmony import */ var hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95967);

/**
 *
 * This function generates a formatted input object for content groq queries, including the query string, source, parameters, and preview status.
 *
 */ var getContentInputQuery = function(param) {
    var query = param.query, context = param.context, params = param.params;
    return {
        input: {
            query: query.replace(/[\n]+/g, "").replace(/\s\s+/g, ""),
            src: context.query.src,
            params: params,
            draft: context.query.draft,
            preview: (0,hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_0__/* .groqPreviewInput */ .i8)(context.query)
        }
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9372,1489,2779,9294,2042,6740,769,7002,9774,2888,179], function() { return __webpack_exec__(4055); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);